/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {SuccessCover, SuccessLayout, SuccessQuote, SuccessRate, SuccessSupport, BlogSocials, Meta} from "@/comps/index";
import {assetUrl} from "@/utils/cdn";
import {getServerSideProps as SSG} from "@/ssr/common";
export const getServerSideProps = SSG;
const MDXLayout = SuccessLayout;
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Meta, {
      title: "Creator success story - @alesdanz",
      description: "Learn from inspiring success stories of Zoomerang creators on creating and selling video templates on Template Marketplace. See how video creators achieved real results with monetization.",
      tags: "#successfulstory, #videocreator, #videotemplate",
      cover: assetUrl("/covers/success-story.jpg")
    }), "\n", _jsx(SuccessCover, {
      username: "alesdanz",
      nickname: "Alesdanz",
      short: "Alesdanz",
      source: "alesdanz",
      title: "Ready to turn your created content into a reliable source of income while having fun?",
      paragraphs: ["I always had a passion for video making, but I never thought that filming and editing videos on my phone could turn into a career. Starting with no experience, I found success on the short-form video platforms by creating catchy and engaging content.", "It's been a wild ride, but my passion for video making and dedication to creating content that resonates with people has been the key to my success. I can't wait to see where this journey takes me next!"]
    }), "\n", _jsx(SuccessRate, {
      engagement: "30%",
      followers: "55K",
      revenue: "$2,000+",
      title: "Expanding Reach and Growing Revenue",
      advice: "As a creator, my main goal with Zoomerang is to showcase my short-form content to a wider audience and generate revenue."
    }), "\n", _jsx(SuccessSupport, {
      engagement: "30%",
      followers: "55K",
      revenue: "$2,000+",
      support: "The Zoomerang team has been a great support for me in the process of creating and monetizing my content. Thanks to their assistance, I have been able to access intuitive tools and features that have allowed me to produce high-quality videos. Additionally, I have received valuable insights on how to expand my audience and generate revenue through my work.",
      success: "Ever since I started using Zoomerang as a content creator, I've seen a notable improvement in my engagement rates across other social media platforms, as well as an increase in followers and earnings. Here are some of my achievements since joining:"
    }), "\n", _jsx(SuccessQuote, {
      name: "Alesdanz",
      role: "Template Creator at Zoomerang",
      quote: "I joined Zoomerang to create short and fun videos, and thanks to this application, I have been able to earn a stable income. If you have skills in video editing, I highly recommend that you join the Zoomerang Template Marketplace.",
      source: "alesdanz"
    }), "\n", _jsx(BlogSocials, {})]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
